import React, { useState, useEffect } from 'react'
import { numberParseChina, repairFormatNum, fmoney, mergeRepeatArr } from "@/utils/utils";
import { useMaintenanceModel } from '../maintenanceModel';
import { maintenanceService } from "../maintenanceService"
import { IMaterialDetailList, IItemDetailList, IMaintenanceDetail } from '../maintenanceType';
import { SettlePrint, IPrintClumns } from "@/components/settlePrint"
import moment from 'moment';
import { useDictModel } from '@/views/base/dict/dictModel';
import useGlobalModel from '@/model/globalModel';
export const Print = () => {
    const {
        print: visible,
        selectedRow,
        setPrint,
        loadData
    } = useMaintenanceModel();
    const [formVal, setFormVal] = useState<IMaintenanceDetail>({});
    const [maintenanceList, setMaintenanceList] = useState<IMaterialDetailList[]>([]);
    const [itemList, setItemList] = useState<IItemDetailList[]>([]);
    const { getTreeNodeName } = useDictModel();
    const { shopAndOrg: { shopCode, shopName } } = useGlobalModel()
    useEffect(() => {
        visible && getDetailOne()
    }, [visible])
    const getDetailOne = async () => {
        let { retData } = await maintenanceService.one(selectedRow.maintenanceCode as string);
        let { itemDetails, materialDetails, receivableTotalAmount, enterTime, ...from } = retData
        receivableTotalAmount = repairFormatNum(receivableTotalAmount)
        const newItemDetails = itemDetails?.map((item, index) => {
            return {
                ...item,
                No: index + 1
            }
        })
        let mergeDetails = await mergeRepeatArr(materialDetails as IMaterialDetailList[], "receivableAmount") as IMaterialDetailList[];

        const newMaterialDetails = mergeDetails?.map((item, index) => {
            return {
                ...item,
                No: index + 1
            }
        })
        if (retData) {
            setMaintenanceList(newMaterialDetails as IMaterialDetailList[] ?? []);
            setItemList(newItemDetails as IItemDetailList[] ?? []);
            setFormVal({ ...from, receivableTotalAmount, receivableTotalAmountCN: numberParseChina(receivableTotalAmount), enterTime: enterTime })
        }
    }
    const printNum = async () => {
        await maintenanceService.printNum(selectedRow.id as string);
        await loadData();
    }
    const onClose = () => {
        setPrint(false)
    }
    const itemClumns = [
        {
            title: '序号',
            dataIndex: 'No',
        },
        {
            title: '项目编号',
            dataIndex: 'itemCode',
        },
        {
            title: '项目名称',
            dataIndex: 'itemName',
        },
        {
            title: '工时费',
            dataIndex: 'receivableAmount',
        },
        {
            title: '工时',
            dataIndex: 'workHour',
        },
        {
            title: '实际工时',
            dataIndex: 'workHour',
        },
        // {
        //     title: '工时',
        //     dataIndex: 'workHour',
        // },
        // {
        //     title: '单价',
        //     dataIndex: 'price',
        //     render: (text: string) => fmoney(text, 2)
        // },
        // {
        //     title: '折扣',
        //     dataIndex: 'discountRate',
        //     render: (text: string) => text + "%"
        // },
        // {
        //     title: '工时费',
        //     dataIndex: 'receivableAmount',
        //     render: (text: string) => fmoney(text, 2)
        // },
        // {
        //     title: '备注',
        //     dataIndex: 'note',
        // },
    ]
    const columns = [
        {
            title: '序号',
            dataIndex: 'No',
        },
        {
            title: '材料编号',
            dataIndex: 'materialCode',
        },
        {
            title: '材料名称',
            dataIndex: 'materialName',
        },
        {
            title: '单位',
            dataIndex: 'unitName',
        },
        {
            title: '数量',
            dataIndex: 'num',
        },
        {
            title: '单价',
            dataIndex: 'price',
            render: (text: string) => fmoney(text, 2)
        },
        // {
        //     title: '折扣',
        //     dataIndex: 'discountRate',
        //     render: (text: string) => text + "%"
        // },
        {
            title: '金额',
            dataIndex: 'receivableAmount',
            render: (text: string) => fmoney(text, 2)
        },
        {
            title: '备注',
            dataIndex: 'note',
        },
    ]
    let IHeader = [
        {
            fieldLabel: "单据编号：",
            fieldValue: `${formVal.maintenanceCode}    (${getTreeNodeName(formVal.status)})`
        }, {
            fieldLabel: "结算方：",
            fieldValue: formVal.settlementPartyName, //getTreeNodeName(formVal.payType as string)
        }, {
            fieldLabel: "结算类型：",
            fieldValue: getTreeNodeName(formVal.payType as string)
        }, {
            fieldLabel: "打印日期：",
            fieldValue: moment(new Date()).format("YYYY-MM-DD HH:mm")
        },
    ]
    return (
        <SettlePrint
            title={`${shopName}修理结算单`}
            visible={visible}
            onClose={onClose}
            printNum={printNum}
            columns={columns as IPrintClumns[]}
            itemClumns={itemClumns as IPrintClumns[]}
            itemDataSource={itemList}
            dataSource={maintenanceList.filter(item => item.num !== 0)}
            printHeader={formVal}
            printFooter={formVal}
            IHeader={IHeader}
        />

    )
}